document.querySelectorAll( '.b-accordion, .b-accordion-boxes' ).forEach( ( block ) => {

	if ( block.dataset.accordionInitialized === 'true' ) {

		return;

	}

	block.dataset.accordionInitialized = 'true';

	/**
	 * Convert mosaic accordion list into two fixed columns.
	 *
	 * @param {HTMLElement} rootBlock Root accordion block.
	 * @return {void}
	 */
	const initializeMosaicColumns = ( rootBlock ) => {

		rootBlock.querySelectorAll( '.b-accordion__items--mosaic' ).forEach( ( mosaicItems ) => {

			if ( mosaicItems.dataset.mosaicInitialized === 'true' ) {

				return;

			}

			const accordionItems = Array.from( mosaicItems.children ).filter(
				( child ) => child.classList.contains( 'b-accordion__item' )
			);

			if ( accordionItems.length < 2 ) {

				mosaicItems.dataset.mosaicInitialized = 'true';

				return;

			}

			const leftColumn = document.createElement( 'div' );
			leftColumn.className = 'b-accordion__mosaic-column b-accordion__mosaic-column--left';

			const rightColumn = document.createElement( 'div' );
			rightColumn.className = 'b-accordion__mosaic-column b-accordion__mosaic-column--right';

			accordionItems.forEach( ( item, index ) => {

				if ( index % 2 === 0 ) {

					leftColumn.appendChild( item );

					return;

				}

				rightColumn.appendChild( item );

			} );

			mosaicItems.appendChild( leftColumn );
			mosaicItems.appendChild( rightColumn );
			mosaicItems.dataset.mosaicInitialized = 'true';

		} );

	};
	initializeMosaicColumns( block );

	const accordions = block.querySelectorAll( '.b-accordion__item' );

	accordions.forEach( ( accordion ) => {

		const accordionHead = accordion.querySelector( '.wp-block-heading' );
		const content = accordion.querySelector( '.b-accordion__item-content' );

		if ( !accordionHead || !content ) {

			return;

		}

		accordionHead.addEventListener( 'click', () => {

			accordion.classList.toggle( 'active' );
			content.style.maxHeight = content.style.maxHeight ? null : `${content.scrollHeight}px`;

		} );

	} );

	/**
	 * Debounce
	 *
	 * @param {function} callback
	 * @param {integer} delay
	 * @return {(function(...[*]): void)|*}
	 */
	const debounce = ( callback, delay ) => {

		let timeout;
		return function executedFunction( ...args ) {

			/** */
			const later = () => {

				clearTimeout( timeout );
				callback( ...args );

			};
			clearTimeout( timeout );
			timeout = setTimeout( later, delay );

		};

	}
	/**
	 * Recalculate heights of open accordion items on window resize
	 */
	const recalculateOpenAccordions = () => {

		block.querySelectorAll( '.b-accordion__item.active' ).forEach( ( accordion ) => {

			const content = accordion.querySelector( '.b-accordion__item-content' );
			const newHeight = content.scrollHeight;
			content.style.maxHeight = `${newHeight}px`;

		} );

	};
	const debounceRecalculateAccordion = debounce( recalculateOpenAccordions, 50 );
	window.addEventListener( 'resize', debounceRecalculateAccordion );

} );
